
























































import GlobalMixin from "@/shared/mixins/globalMixin";
import Component from "vue-class-component";
import { Mixins, Prop, Watch } from "vue-property-decorator";

import { Dashboard, DashboardService } from "@/services/dashboard.service";

import { moeda } from "@/shared/filters";

import CardItem from "../../CardIcon.vue";
import Faturamento from "./Faturamento.vue";

@Component({
  components: { CardItem, Faturamento },
  filters: { moeda },
})
export default class Resumo extends Mixins(GlobalMixin) {
  loading = false;
  date: string | null = null;
  resumo: Dashboard = {
    faturamentoPeriodo: [],
    mediaDia: 0,
    planos: 0,
    projetado: 0,
    totalFaturado: 0,
    totalTaxas: 0,
  };

  @Prop() readonly value!: string;
  mounted() {
    this.onValueChange(this.value);
  }

  @Watch("value")
  onValueChange(val: string) {
    this.loading = true;
    if (val) {
      this.date = val;
      DashboardService.financeiro(this.date)
        .then((res) => {
          this.resumo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
